import { cn } from '../cn'
import { Skeleton } from './skeleton'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from './table'

type ColumnWidth = string | number

interface TableSkeletonProps {
  rows?: number
  columns?: number
  showHeader?: boolean
  headerHeight?: number
  rowHeight?: number
  columnWidths?: ColumnWidth[]
  className?: string
  tableClassName?: string
  rowClassName?: string
  cellClassName?: string
}

const DEFAULT_COLUMN_WIDTHS = ['35%', '20%', '18%', '14%', '10%']
export const TABLE_SKELETON_HEADER_HEIGHT = 40
export const TABLE_SKELETON_ROW_HEIGHT = 50

function getColumnWidth(columnIndex: number, columnWidths: ColumnWidth[]) {
  const width =
    columnWidths[columnIndex] ??
    DEFAULT_COLUMN_WIDTHS[columnIndex % DEFAULT_COLUMN_WIDTHS.length]

  return typeof width === 'number' ? `${width}px` : width
}

export function TableSkeleton({
  rows = 5,
  columns = 5,
  showHeader = true,
  headerHeight = TABLE_SKELETON_HEADER_HEIGHT,
  rowHeight = TABLE_SKELETON_ROW_HEIGHT,
  columnWidths = DEFAULT_COLUMN_WIDTHS,
  className,
  tableClassName,
  rowClassName,
  cellClassName,
}: TableSkeletonProps) {
  const columnIndexes = Array.from({ length: columns }, (_, index) => index)
  const rowIndexes = Array.from({ length: rows }, (_, index) => index)

  return (
    <div className={cn('border-border rounded-sm border', className)}>
      <Table className={tableClassName}>
        {showHeader && (
          <TableHeader>
            <TableRow
              className='hover:bg-transparent'
              style={{ height: headerHeight }}
            >
              {columnIndexes.map((columnIndex) => (
                <TableHead key={columnIndex}>
                  <Skeleton
                    className='h-3 rounded-sm'
                    style={{ width: getColumnWidth(columnIndex, columnWidths) }}
                  />
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
        )}
        <TableBody>
          {rowIndexes.map((rowIndex) => (
            <TableRow
              key={rowIndex}
              className={rowClassName}
              style={{ height: rowHeight }}
            >
              {columnIndexes.map((columnIndex) => (
                <TableCell key={columnIndex} className={cellClassName}>
                  <Skeleton
                    className='h-4 rounded-sm'
                    style={{ width: getColumnWidth(columnIndex, columnWidths) }}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
